module.exports = __webpack_public_path__ + "img/26.d8886cc3.jpg";